import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api/client";
import { Spinner } from "../components/UI";
import PersoenlicheNotizen from "../components/PersoenlicheNotizen";
import { getAuthHeader } from "../auth/AuthContext";

export default function VorlageDetail() {
  const { id } = useParams();
  const [vorlage, setVorlage] = useState(null);
  const [workflow, setWorkflow] = useState(null);
  const [beratungsfolge, setBeratungsfolge] = useState(null);
  const [veroeffentlichung, setVeroeffentlichung] = useState(null);
  const [kommentar, setKommentar] = useState("");
  const [gremien, setGremien] = useState([]);
  const [neuesGremiumId, setNeuesGremiumId] = useState("");
  const [empfehlungText, setEmpfehlungText] = useState({});
  const [anlagen, setAnlagen] = useState([]);

  const laden = () => {
    api.getVorlage(id).then(setVorlage);
    api.getWorkflowStatus("vorlage", id).then(setWorkflow).catch(() => setWorkflow(null));
    api.getBeratungsfolge(id).then(setBeratungsfolge);
    api.getVeroeffentlichung("vorlage", id).then(setVeroeffentlichung).catch(() => {});
    api.getGremien().then(setGremien).catch(() => {});
    api.getVorlageAnlagen(id).then(setAnlagen).catch(() => {});
  };
  useEffect(() => { laden(); }, [id]);

  if (!vorlage) return <Spinner />;

  const weiterleiten = async () => {
    await api.workflowWeiterleiten(workflow.id, kommentar);
    setKommentar("");
    laden();
  };
  const ablehnen = async () => {
    await api.workflowAblehnen(workflow.id, kommentar);
    setKommentar("");
    laden();
  };
  const freigeben = async () => { await api.vorlageFreigeben(id); laden(); };
  const zurueckziehen = async () => { await api.vorlageZurueckziehen(id); laden(); };
  const veroeffentlichen = async () => { await api.veroeffentlichen("vorlage", id); laden(); };
  const veroeffentlichungZurueckziehen = async () => { await api.veroeffentlichungZurueckziehen("vorlage", id); laden(); };

  const stufeHinzufuegen = async () => {
    if (!neuesGremiumId) return;
    const naechsteReihenfolge = (beratungsfolge?.length || 0) + 1;
    await api.addBeratungsschritt(id, { gremium_id: parseInt(neuesGremiumId, 10), reihenfolge: naechsteReihenfolge });
    setNeuesGremiumId("");
    laden();
  };

  const empfehlungSpeichern = async (bid) => {
    await api.updateBeratungsschritt(id, bid, { empfehlung: empfehlungText[bid] || "", status: "beraten" });
    laden();
  };

  const stufeAbschliessen = async (bid) => {
    await api.updateBeratungsschritt(id, bid, { status: "beschlossen" });
    laden();
  };

  const anlageHochladen = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    await api.uploadVorlageAnlage(id, file);
    e.target.value = "";
    laden();
  };

  const vorlagePdfOeffnen = async () => {
    try {
      const authHeader = await getAuthHeader();
      const res = await fetch(`/api/vorlagen/${id}/vorlage.pdf`, { headers: authHeader });
      if (!res.ok) { window.alert("PDF konnte nicht erzeugt werden"); return; }
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob), "_blank");
    } catch (e) { window.alert("Fehler: " + e.message); }
  };

  const anlageOeffnen = async (aid) => {
    try {
      const authHeader = await getAuthHeader();
      const res = await fetch(api.vorlageAnlageUrl(aid), { headers: authHeader });
      if (!res.ok) { window.alert("PDF konnte nicht geladen werden"); return; }
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob), "_blank");
    } catch (e) { window.alert("Fehler: " + e.message); }
  };

  const anlageLoeschen = async (aid) => {
    if (!window.confirm("Anlage löschen?")) return;
    await api.deleteVorlageAnlage(aid);
    laden();
  };

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <Link to="/vorlagen" style={{ fontSize: 13, color: "#666" }}>← Zurück zur Übersicht</Link>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: 8, marginBottom: 4 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>{vorlage.titel}</h1>
          <div style={{ fontSize: 13, color: "#666" }}>{vorlage.vorlagennummer || "Noch keine Nummer"} · {vorlage.status}</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-secondary" onClick={vorlagePdfOeffnen}>PDF öffnen</button>
          {vorlage.status === "entwurf" && (
            <>
              <Link to={`/vorlagen/${id}/bearbeiten`}><button className="btn btn-secondary">Bearbeiten</button></Link>
              <button className="btn btn-primary" onClick={freigeben}>Freigeben</button>
            </>
          )}
          {vorlage.status !== "entwurf" && vorlage.status !== "zurueckgezogen" && (
            <button className="btn btn-secondary" onClick={zurueckziehen}>Zurückziehen</button>
          )}
        </div>
      </div>

      <div className="card" style={{ padding: 20, marginTop: 20 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Details</h2>
        {vorlage.sachverhalt && <p><strong>Sachverhalt:</strong> {vorlage.sachverhalt}</p>}
        {vorlage.beschlussvorschlag && <p><strong>Beschlussvorschlag:</strong> {vorlage.beschlussvorschlag}</p>}
        {vorlage.finanzielle_auswirkungen && <p><strong>Finanzielle Auswirkungen:</strong> {vorlage.finanzielle_auswirkungen}</p>}
      </div>

      <div className="card" style={{ padding: 20, marginTop: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Anlagen</h2>
        {anlagen.length > 0 && (
          <div style={{ marginBottom: 10 }}>
            {anlagen.map(a => (
              <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
                <button onClick={() => anlageOeffnen(a.id)} style={{ flex: 1, textAlign: "left", background: "none", border: "none", color: "var(--primary)", cursor: "pointer", padding: 0, textDecoration: "underline", font: "inherit" }}>{a.dateiname}</button>
                <span style={{ fontSize: 11, color: "var(--ink-faint)" }}>{a.groesse_bytes ? `${Math.round(a.groesse_bytes / 1024)} KB` : ""}</span>
                <button className="btn btn-ghost btn-sm" style={{ color: "var(--danger)" }} onClick={() => anlageLoeschen(a.id)}>Entfernen</button>
              </div>
            ))}
          </div>
        )}
        <label className="btn btn-secondary btn-sm" style={{ cursor: "pointer" }}>
          PDF hochladen
          <input type="file" accept="application/pdf" onChange={anlageHochladen} style={{ display: "none" }} />
        </label>
      </div>

      {workflow?.status && (
        <div className="card" style={{ padding: 20, marginTop: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Freigabe-Workflow</h2>
          <div style={{ fontSize: 13, color: "#666", marginBottom: 8 }}>Status: {workflow.status}</div>
          {workflow.status === "laufend" && (
            <>
              <div style={{ marginBottom: 12 }}>Aktueller Schritt: <strong>{workflow.aktueller_schritt?.bezeichnung}</strong></div>
              <textarea className="form-control" placeholder="Kommentar (optional)" value={kommentar}
                        onChange={e => setKommentar(e.target.value)} rows={2} style={{ marginBottom: 8 }} />
              <div style={{ display: "flex", gap: 8 }}>
                <button className="btn btn-primary" onClick={weiterleiten}>Weiterleiten</button>
                <button className="btn btn-secondary" onClick={ablehnen}>Ablehnen</button>
              </div>
            </>
          )}
          <div style={{ marginTop: 16, fontSize: 12, color: "#999" }}>
            {workflow.protokoll.map((p, i) => (
              <div key={i}>{p.zeitpunkt?.slice(0, 10)} · {p.aktion} {p.benutzer_email && `(${p.benutzer_email})`}</div>
            ))}
          </div>
        </div>
      )}

      <div className="card" style={{ padding: 20, marginTop: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Beratungsfolge</h2>
        <div style={{ fontSize: 11, color: "var(--ink-faint)", marginBottom: 12 }}>
          Die Reihenfolge, in der diese Vorlage durch die Gremien läuft — z.B. zuerst im Jugendgremium eingebracht, dann an das übergeordnete Gremium weitergeleitet.
        </div>

        {beratungsfolge && beratungsfolge.map((b, i) => {
          const gremiumName = gremien.find(g => g.id === b.gremium_id)?.name || `Gremium #${b.gremium_id}`;
          const istAktuelleStufe = beratungsfolge.slice(0, i).every(x => x.status === "beschlossen") && b.status !== "beschlossen";
          return (
            <div key={b.id} style={{
              padding: "10px 0", borderBottom: "1px solid var(--border)",
              opacity: b.status === "beschlossen" ? 0.6 : 1,
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ color: "var(--ink-faint)" }}>{b.reihenfolge}.</span>
                <strong>{gremiumName}</strong>
                <span className={`badge badge-${b.status === "beschlossen" ? "durchgefuehrt" : b.status === "beraten" ? "eingeladen" : "geplant"}`}>
                  {b.status === "geplant" ? "Geplant" : b.status === "beraten" ? "Beraten" : "Abgeschlossen"}
                </span>
                {istAktuelleStufe && <span style={{ fontSize: 10, color: "var(--primary)", fontWeight: 600 }}>← AKTUELL</span>}
              </div>
              {b.empfehlung && <div style={{ fontSize: 12.5, color: "var(--ink-soft)", marginTop: 4 }}>Empfehlung: {b.empfehlung}</div>}

              {istAktuelleStufe && (
                <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "flex-start" }}>
                  <input className="form-control" style={{ maxWidth: 260 }} placeholder="Empfehlung dieser Stufe"
                    value={empfehlungText[b.id] ?? b.empfehlung ?? ""}
                    onChange={e => setEmpfehlungText(t => ({ ...t, [b.id]: e.target.value }))} />
                  <button className="btn btn-secondary btn-sm" onClick={() => empfehlungSpeichern(b.id)}>Empfehlung speichern</button>
                  <button className="btn btn-primary btn-sm" onClick={() => stufeAbschliessen(b.id)}>Stufe abschließen & weiterleiten</button>
                </div>
              )}
            </div>
          );
        })}

        <div style={{ marginTop: 12, display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ maxWidth: 220 }} value={neuesGremiumId} onChange={e => setNeuesGremiumId(e.target.value)}>
            <option value="">Gremium wählen…</option>
            {gremien.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
          </select>
          <button className="btn btn-secondary btn-sm" onClick={stufeHinzufuegen}>
            {beratungsfolge && beratungsfolge.length > 0 ? "Nächste Stufe hinzufügen" : "Erste Stufe hinzufügen"}
          </button>
        </div>
      </div>

      {veroeffentlichung && vorlage.status !== "entwurf" && (
        <div className="card" style={{ padding: 20, marginTop: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Veröffentlichung</h2>
          <div style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>
            Status: {veroeffentlichung.status} {veroeffentlichung.oeffentlich_sichtbar && "· im Bürgerportal sichtbar"}
          </div>
          {!veroeffentlichung.oeffentlich_sichtbar ? (
            <button className="btn btn-primary" onClick={veroeffentlichen}>Im Bürgerportal veröffentlichen</button>
          ) : (
            <button className="btn btn-secondary" onClick={veroeffentlichungZurueckziehen}>Veröffentlichung zurückziehen</button>
          )}
        </div>
      )}

      <PersoenlicheNotizen objektTyp="vorlage" objektId={parseInt(id, 10)} />
    </div>
  );
}
